import { CountryCodes } from '@/generated/graphql';
import { features } from '@/lib/features';
import { getLocale } from '@/lib/globals';

/**
 * LI-157143: US optional/forced signup existing-account email lookup + AAE,
 * decoupled from deprecated member-matching / suppressSignup Elmos.
 * Excludes billing agreements to match FEATURE_EXPAND_MEMBER_MATCHING ELMO filters.
 */
export const isExistingAccountEmailLookupEligible = (): boolean => {
  const { country } = getLocale();
  const isOptionalSignup = features.isActive('isOptionalSignup');
  const isForcedSignup = features.isActive('isForcedSignUp');
  const isBillingAgreement = features.isActive('isBillingAgreement');

  return (
    country === CountryCodes.Us &&
    (isForcedSignup || isOptionalSignup) &&
    !isBillingAgreement
  );
};
